import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const download = (pdf) => {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = "archive.pdf";

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

export const getFiles = async () => (
  axios.get("/files")
)

export const getSignedFiles = async (keys) => (
  axios.post("/signed_files", {
    keys
  })
)

export const generatePDF = async (keys) => (
  axios.post("/pdf", {
    keys, responseType: 'arrayBuffer'
  }).then(response => download(response.data))
)